import React, { Component } from 'react';
import {Colors} from './../../utils/constants';
import {Link} from "react-router-dom";
import FullPageBreak from './../../components/fullPageBreak';
import {Helmet} from "react-helmet";
import ColorSection from './colorSection';
import FontSection from './fontSection';
import LogoSection from './logoSection';
import PowerpointSection from './powerpointSection';
import LetterheadSection from './letterheadSection';
import ImagesSection from './imagesSection';
import EmailSection from './emailSection';
import ChartSection from './visualizationSection';
import BiosSection from './biosSection';
import SigmaSection from './sigmaSection';
import OverviewSection from './overviewSection';
import MethodologySection from './methodologySection';
import AISection from './aiSection';
import DesignSearch from './designSearch';
import './design-dashboard.css';

// Sections on the Methodology page (ids must match the section ids in methodologySection.js)
const METHODOLOGY_SECTIONS = [
  { id: 'simplicity-focus', label: 'Simplicity & Focus' },
  { id: 'intuitive-cohesive', label: 'Intuitive & Cohesive' },
  { id: 'communicate-forgive', label: 'Communicate & Forgive' },
  { id: 'grounded-in-people', label: 'Grounded in People' },
  { id: 'data-visualization', label: 'Data Visualization' },
  { id: 'resources', label: 'Resources' },
];

export default class DesignDashboard extends Component {
  constructor(props) {
      super(props);
      const { page } = props.match.params;
      this.state={
        mobileMenuActive: false,
        colorsExpanded: page === 'colors',
        activeSubnav: null,
        imageryExpanded: page === 'imagery',
        activeImagerySubnav: null,
        methodologyExpanded: page === 'methodology',
        activeMethodologySubnav: null
      };
  }
  componentDidMount() {
    const { page } = this.props.match.params;
    if (page === 'colors') {
      setTimeout(() => this.setupScrollObserver(), 100);
    }
    if (page === 'imagery') {
      setTimeout(() => this.setupImageryScrollObserver(), 100);
    }
    if (page === 'methodology') {
      setTimeout(() => this.setupMethodologyScrollObserver(), 100);
    }
  }
  componentDidUpdate(prevProps) {
    const { page } = this.props.match.params;
    const prevPage = prevProps.match.params.page;
    if (page !== prevPage) {
      const scrollTo = this.props.location && this.props.location.state && this.props.location.state.scrollTo;
      if (!scrollTo) {
        const content = document.querySelector('.design-dashboard-content');
        if (content) content.scrollTop = 0;
      }
    }
    if (page === 'colors' && prevPage !== 'colors') {
      this.setState({ colorsExpanded: true });
      const scrollTo = this.props.location && this.props.location.state && this.props.location.state.scrollTo;
      if (scrollTo) {
        this.setState({ activeSubnav: scrollTo });
        setTimeout(function() {
          var el = document.getElementById(scrollTo);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
      setTimeout(() => this.setupScrollObserver(), 100);
    }
    if (prevPage === 'colors' && page !== 'colors') {
      this.teardownScrollObserver();
      this.setState({ activeSubnav: null });
    }
    if (page === 'imagery' && prevPage !== 'imagery') {
      this.setState({ imageryExpanded: true });
      const scrollTo = this.props.location && this.props.location.state && this.props.location.state.scrollTo;
      if (scrollTo) {
        this.setState({ activeImagerySubnav: scrollTo });
        setTimeout(function() {
          var el = document.getElementById(scrollTo);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
      setTimeout(() => this.setupImageryScrollObserver(), 100);
    }
    if (prevPage === 'imagery' && page !== 'imagery') {
      this.teardownImageryScrollObserver();
      this.setState({ activeImagerySubnav: null });
    }
    if (page === 'methodology' && prevPage !== 'methodology') {
      this.setState({ methodologyExpanded: true });
      const scrollTo = this.props.location && this.props.location.state && this.props.location.state.scrollTo;
      if (scrollTo) {
        this.setState({ activeMethodologySubnav: scrollTo });
        setTimeout(function() {
          var el = document.getElementById(scrollTo);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
      setTimeout(() => this.setupMethodologyScrollObserver(), 100);
    }
    if (prevPage === 'methodology' && page !== 'methodology') {
      this.teardownMethodologyScrollObserver();
      this.setState({ activeMethodologySubnav: null });
    }
  }
  componentWillUnmount() {
    this.teardownScrollObserver();
    this.teardownImageryScrollObserver();
    this.teardownMethodologyScrollObserver();
  }
  setupMethodologyScrollObserver() {
    this.teardownMethodologyScrollObserver();
    var scrollContainer = document.querySelector('.design-dashboard-content');
    if (!scrollContainer) return;
    const updateActive = () => {
      const sections = METHODOLOGY_SECTIONS.map(s => s.id);
      const containerTop = scrollContainer.getBoundingClientRect().top;
      let active = sections[0];
      for (const id of sections) {
        const el = document.getElementById(id);
        if (!el) continue;
        if (el.getBoundingClientRect().top - containerTop <= 150) {
          active = id;
        }
      }
      this.setState({ activeMethodologySubnav: active });
    };
    scrollContainer.addEventListener('scroll', updateActive);
    this._methodologyScrollHandler = updateActive;
    updateActive();
  }
  teardownMethodologyScrollObserver() {
    if (this._methodologyScrollHandler) {
      var scrollContainer = document.querySelector('.design-dashboard-content');
      if (scrollContainer) scrollContainer.removeEventListener('scroll', this._methodologyScrollHandler);
      this._methodologyScrollHandler = null;
    }
  }
  setupScrollObserver() {
    this.teardownScrollObserver();
    var scrollContainer = document.querySelector('.design-dashboard-content');
    if (!scrollContainer) return;
    const updateActive = () => {
      const sections = ['brand-colors', 'chart-core-colors', 'chart-sequential-colors', 'chart-diverging-colors', 'ui-colors'];
      const containerTop = scrollContainer.getBoundingClientRect().top;
      let active = 'brand-colors';
      for (const id of sections) {
        const el = document.getElementById(id);
        if (!el) continue;
        if (el.getBoundingClientRect().top - containerTop <= 150) {
          active = id;
        }
      }
      this.setState({ activeSubnav: active });
    };
    scrollContainer.addEventListener('scroll', updateActive);
    this._colorsScrollHandler = updateActive;
    updateActive();
  }
  teardownScrollObserver() {
    if (this._colorsScrollHandler) {
      var scrollContainer = document.querySelector('.design-dashboard-content');
      if (scrollContainer) scrollContainer.removeEventListener('scroll', this._colorsScrollHandler);
      this._colorsScrollHandler = null;
    }
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
  setupImageryScrollObserver() {
    this.teardownImageryScrollObserver();
    var scrollContainer = document.querySelector('.design-dashboard-content');
    var zoomEl = document.getElementById('zoom-backgrounds');
    var photoEl = document.getElementById('photography');
    if (!scrollContainer || !zoomEl || !photoEl) return;
    this.imageryIntersecting = { 'zoom-backgrounds': false, 'photography': false };
    this.imageryObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.imageryIntersecting[entry.target.id] = entry.isIntersecting;
      });
      if (this.imageryIntersecting['photography']) {
        this.setState({ activeImagerySubnav: 'photography' });
      } else if (this.imageryIntersecting['zoom-backgrounds']) {
        this.setState({ activeImagerySubnav: 'zoom-backgrounds' });
      } else {
        this.setState({ activeImagerySubnav: 'linkedin-banners' });
      }
    }, { root: scrollContainer, threshold: 0 });
    this.imageryObserver.observe(zoomEl);
    this.imageryObserver.observe(photoEl);
  }
  teardownImageryScrollObserver() {
    if (this.imageryObserver) {
      this.imageryObserver.disconnect();
      this.imageryObserver = null;
    }
  }
  toggleMobileMenu = () =>{
    if(this.state.mobileMenuActive){
      this.setState({ mobileMenuActive: false });
    } else{
      this.setState({ mobileMenuActive: true });
    }
  }
  toggleColorsExpanded = (e) => {
    e.stopPropagation();
    this.setState(prev => ({ colorsExpanded: !prev.colorsExpanded }));
  }
  toggleImageryExpanded = (e) => {
    e.stopPropagation();
    this.setState(prev => ({ imageryExpanded: !prev.imageryExpanded }));
  }
  toggleMethodologyExpanded = (e) => {
    e.stopPropagation();
    this.setState(prev => ({ methodologyExpanded: !prev.methodologyExpanded }));
  }

  render() {
    let { page } = this.props.match.params;
    let mobileMenuActiveClass = this.state.mobileMenuActive ? 'mobile-menu-open' :'';
    return (
      <div className="full-height full-width" style={{display:'flex', flexDirection:'column'}}>
        <Helmet>
          <title>Design | YipitData</title>
          <meta name="description" content="The system and design methodology contributing to YipitData's suite of products and services." />
          <link type="text/css" media="screen" rel="stylesheet" href="https://trends.edison.tech/assets/twentytwenty/css/twentytwenty.css"/>
          <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded"/>
        </Helmet>

        <div className="design-dashboard-topbar">
          <button className="design-dashboard-menu-toggle" onClick={this.toggleMobileMenu} aria-label="Toggle navigation">
            <span className="material-symbols-rounded">menu</span>
          </button>
          <Link to="/">
            <img alt="YipitData logo" className="design-dashboard-topbar-logo" src={"/images/logo-light.png"} />
          </Link>
          <span className="design-dashboard-topbar-title">{'Design'}</span>
          <DesignSearch />
        </div>
        <div className={"design-dashboard-container "+mobileMenuActiveClass}>
          {this.state.mobileMenuActive && <div className="design-dashboard-nav-backdrop" onClick={this.toggleMobileMenu} />}
          <div className="design-dashboard-navigation" onClick={this.toggleMobileMenu}>
            <div className={!page ? 'design-dashboard-navigation-item active' : 'design-dashboard-navigation-item'}>
              <Link to="/design">{'Overview'}</Link>
            </div>
            <div className={page == 'methodology' ? 'design-dashboard-navigation-item active' : 'design-dashboard-navigation-item'}>
              <div className="nav-accordion-header">
                <Link to="/design/methodology">{'Methodology'}</Link>
                <span className={`nav-accordion-toggle${this.state.methodologyExpanded ? ' expanded' : ''}`} onClick={this.toggleMethodologyExpanded}>
                  <span className="material-symbols-rounded">keyboard_arrow_down</span>
                </span>
              </div>
              {this.state.methodologyExpanded && (
                <div className="design-dashboard-subnav">
                  {METHODOLOGY_SECTIONS.map((section) => (
                    <Link
                      key={section.id}
                      className={'design-dashboard-subnav-item' + (this.state.activeMethodologySubnav === section.id ? ' active' : '')}
                      to={{ pathname: '/design/methodology', state: { scrollTo: section.id } }}
                      onClick={(e) => { this.setState({ activeMethodologySubnav: section.id }); if (page === 'methodology') { e.preventDefault(); const el = document.getElementById(section.id); if (el) el.scrollIntoView({ behavior: 'smooth' }); } }}>
                      {section.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <div className={page == 'logo' ? 'design-dashboard-navigation-item active' : 'design-dashboard-navigation-item'}>
              <Link to="/design/logo">{'Logos'}</Link>
            </div>
            <div className={page == 'colors' ? 'design-dashboard-navigation-item active' : 'design-dashboard-navigation-item'}>
              <div className="nav-accordion-header">
                <Link to="/design/colors">{'Colors'}</Link>
                <span className={`nav-accordion-toggle${this.state.colorsExpanded ? ' expanded' : ''}`} onClick={this.toggleColorsExpanded}>
                  <span className="material-symbols-rounded">keyboard_arrow_down</span>
                </span>
              </div>
              {this.state.colorsExpanded && (
                <div className="design-dashboard-subnav">
                  <Link
                    className={'design-dashboard-subnav-item' + (this.state.activeSubnav === 'brand-colors' ? ' active' : '')}
                    to={{ pathname: '/design/colors', state: { scrollTo: 'brand-colors' } }}
                    onClick={(e) => { this.setState({ activeSubnav: 'brand-colors' }); if (page === 'colors') { e.preventDefault(); const el = document.getElementById('brand-colors'); if (el) el.scrollIntoView({ behavior: 'smooth' }); } }}>
                    Branding
                  </Link>
                  <Link
                    className={'design-dashboard-subnav-item' + (this.state.activeSubnav === 'chart-core-colors' ? ' active' : '')}
                    to={{ pathname: '/design/colors', state: { scrollTo: 'chart-core-colors' } }}
                    onClick={(e) => { this.setState({ activeSubnav: 'chart-core-colors' }); if (page === 'colors') { e.preventDefault(); const el = document.getElementById('chart-core-colors'); if (el) el.scrollIntoView({ behavior: 'smooth' }); } }}>
                    Chart Colors
                  </Link>
                  <Link
                    className={'design-dashboard-subnav-item' + (this.state.activeSubnav === 'chart-sequential-colors' ? ' active' : '')}
                    to={{ pathname: '/design/colors', state: { scrollTo: 'chart-sequential-colors' } }}
                    onClick={(e) => { this.setState({ activeSubnav: 'chart-sequential-colors' }); if (page === 'colors') { e.preventDefault(); const el = document.getElementById('chart-sequential-colors'); if (el) el.scrollIntoView({ behavior: 'smooth' }); } }}>
                    Sequential Colors
                  </Link>
                  <Link
                    className={'design-dashboard-subnav-item' + (this.state.activeSubnav === 'chart-diverging-colors' ? ' active' : '')}
                    to={{ pathname: '/design/colors', state: { scrollTo: 'chart-diverging-colors' } }}
                    onClick={(e) => { this.setState({ activeSubnav: 'chart-diverging-colors' }); if (page === 'colors') { e.preventDefault(); const el = document.getElementById('chart-diverging-colors'); if (el) el.scrollIntoView({ behavior: 'smooth' }); } }}>
                    Diverging Colors
                  </Link>
                  <Link
                    className={'design-dashboard-subnav-item' + (this.state.activeSubnav === 'ui-colors' ? ' active' : '')}
                    to={{ pathname: '/design/colors', state: { scrollTo: 'ui-colors' } }}
                    onClick={(e) => { this.setState({ activeSubnav: 'ui-colors' }); if (page === 'colors') { e.preventDefault(); const el = document.getElementById('ui-colors'); if (el) el.scrollIntoView({ behavior: 'smooth' }); } }}>
                    User Interface
                  </Link>
                </div>
              )}
            </div>
            <div className={page == 'font' ? 'design-dashboard-navigation-item active' : 'design-dashboard-navigation-item'}>
              <Link to="/design/font">{'Typography'}</Link>
            </div>
            <div className={page == 'slides' ? 'design-dashboard-navigation-item active' : 'design-dashboard-navigation-item'}>
              <Link to="/design/slides">{'Slides'}</Link>
            </div>
            <div className={page == 'letterhead' ? 'design-dashboard-navigation-item active' : 'design-dashboard-navigation-item'}>
              <Link to="/design/letterhead">{'Letterheads'}</Link>
            </div>
            <div className={page == 'imagery' ? 'design-dashboard-navigation-item active' : 'design-dashboard-navigation-item'}>
              <div className="nav-accordion-header">
                <Link to="/design/imagery">{'Imagery'}</Link>
                <span className={`nav-accordion-toggle${this.state.imageryExpanded ? ' expanded' : ''}`} onClick={this.toggleImageryExpanded}>
                  <span className="material-symbols-rounded">keyboard_arrow_down</span>
                </span>
              </div>
              {this.state.imageryExpanded && (
                <div className="design-dashboard-subnav">
                  <Link
                    className={'design-dashboard-subnav-item' + (this.state.activeImagerySubnav === 'linkedin-banners' ? ' active' : '')}
                    to={{ pathname: '/design/imagery', state: { scrollTo: 'linkedin-banners' } }}
                    onClick={(e) => { this.setState({ activeImagerySubnav: 'linkedin-banners' }); if (page === 'imagery') { e.preventDefault(); var el = document.getElementById('linkedin-banners'); if (el) el.scrollIntoView({ behavior: 'smooth' }); } }}>
                    LinkedIn Banners
                  </Link>
                  <Link
                    className={'design-dashboard-subnav-item' + (this.state.activeImagerySubnav === 'zoom-backgrounds' ? ' active' : '')}
                    to={{ pathname: '/design/imagery', state: { scrollTo: 'zoom-backgrounds' } }}
                    onClick={(e) => { this.setState({ activeImagerySubnav: 'zoom-backgrounds' }); if (page === 'imagery') { e.preventDefault(); var el = document.getElementById('zoom-backgrounds'); if (el) el.scrollIntoView({ behavior: 'smooth' }); } }}>
                    Zoom Backgrounds
                  </Link>
                  <Link
                    className={'design-dashboard-subnav-item' + (this.state.activeImagerySubnav === 'photography' ? ' active' : '')}
                    to={{ pathname: '/design/imagery', state: { scrollTo: 'photography' } }}
                    onClick={(e) => { this.setState({ activeImagerySubnav: 'photography' }); if (page === 'imagery') { e.preventDefault(); var el = document.getElementById('photography'); if (el) el.scrollIntoView({ behavior: 'smooth' }); } }}>
                    Photography
                  </Link>
                </div>
              )}
            </div>
            <div className={page == 'email' ? 'design-dashboard-navigation-item active' : 'design-dashboard-navigation-item'}>
              <Link to="/design/email">{'Email Signatures'}</Link>
            </div>
            <div className={page == 'charts' ? 'design-dashboard-navigation-item active' : 'design-dashboard-navigation-item'}>
              <Link to="/design/charts">{'Data Visualizations'}</Link>
            </div>
            <div className={page == 'sigma' ? 'design-dashboard-navigation-item active' : 'design-dashboard-navigation-item'}>
              <Link to="/design/sigma">{'Sigma'}</Link>
            </div>
            <div className={page == 'ai' ? 'design-dashboard-navigation-item active' : 'design-dashboard-navigation-item'}>
              <Link to="/design/ai">{'AI Design Tools'}</Link>
            </div>
          </div>
          <div className="design-dashboard-content">
            {!page &&
              <OverviewSection />
            }
            {page == "methodology" &&
              <div>
                <MethodologySection />
              </div>
            }
            {page == "logo" &&
              <div>
                <LogoSection />
              </div>
            }
            {page == "colors" &&
              <div>
                <ColorSection />
              </div>
            }
            {page == "font" &&
              <div>
                <FontSection />
              </div>
            }
            {page == "slides" &&
              <div>
                <PowerpointSection />
              </div>
            }
            {page == "letterhead" &&
              <div>
                <LetterheadSection />
              </div>
            }
            {page == "email" &&
              <div>
                <EmailSection />
              </div>
            }
            {page == "imagery" &&
              <div>
                <ImagesSection />
              </div>
            }
            {page == "charts" &&
              <div>
                <ChartSection />
              </div>
            }
            {page == "sigma" &&
              <div>
                <SigmaSection />
              </div>
            }
            {page == "ai" &&
              <div>
                <AISection />
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}
